/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authenticate } from '../fn/user/authenticate';
import { authenticate_1 } from '../fn/user/authenticate-1';
import { Authenticate_1$Params } from '../fn/user/authenticate-1';
import { Authenticate$Params } from '../fn/user/authenticate';
import { changelanguage } from '../fn/user/changelanguage';
import { changelanguage_1 } from '../fn/user/changelanguage-1';
import { Changelanguage_1$Params } from '../fn/user/changelanguage-1';
import { changelanguage_2 } from '../fn/user/changelanguage-2';
import { Changelanguage_2$Params } from '../fn/user/changelanguage-2';
import { Changelanguage$Params } from '../fn/user/changelanguage';
import { changePassword } from '../fn/user/change-password';
import { ChangePassword$Params } from '../fn/user/change-password';
import { confirmPassword } from '../fn/user/confirm-password';
import { ConfirmPassword$Params } from '../fn/user/confirm-password';
import { forgotPassword } from '../fn/user/forgot-password';
import { ForgotPassword$Params } from '../fn/user/forgot-password';
import { getAllCountryNames } from '../fn/user/get-all-country-names';
import { GetAllCountryNames$Params } from '../fn/user/get-all-country-names';
import { getDailyOrderIncomings } from '../fn/user/get-daily-order-incomings';
import { GetDailyOrderIncomings$Params } from '../fn/user/get-daily-order-incomings';
import { getMostOrderedItems_2 } from '../fn/user/get-most-ordered-items-2';
import { GetMostOrderedItems_2$Params } from '../fn/user/get-most-ordered-items-2';
import { getUserProfile } from '../fn/user/get-user-profile';
import { getUserProfile_1 } from '../fn/user/get-user-profile-1';
import { GetUserProfile_1$Params } from '../fn/user/get-user-profile-1';
import { getUserProfile_2 } from '../fn/user/get-user-profile-2';
import { GetUserProfile_2$Params } from '../fn/user/get-user-profile-2';
import { GetUserProfile$Params } from '../fn/user/get-user-profile';
import { refreshToken } from '../fn/user/refresh-token';
import { refreshToken_1 } from '../fn/user/refresh-token-1';
import { RefreshToken_1$Params } from '../fn/user/refresh-token-1';
import { RefreshToken$Params } from '../fn/user/refresh-token';
import { register } from '../fn/user/register';
import { Register$Params } from '../fn/user/register';
import { registerFcmToken } from '../fn/user/register-fcm-token';
import { registerFcmToken_1 } from '../fn/user/register-fcm-token-1';
import { RegisterFcmToken_1$Params } from '../fn/user/register-fcm-token-1';
import { registerFcmToken_2 } from '../fn/user/register-fcm-token-2';
import { RegisterFcmToken_2$Params } from '../fn/user/register-fcm-token-2';
import { RegisterFcmToken$Params } from '../fn/user/register-fcm-token';
import { revokeToken } from '../fn/user/revoke-token';
import { revokeToken_1 } from '../fn/user/revoke-token-1';
import { RevokeToken_1$Params } from '../fn/user/revoke-token-1';
import { RevokeToken$Params } from '../fn/user/revoke-token';
import { testFirebirdDb } from '../fn/user/test-firebird-db';
import { TestFirebirdDb$Params } from '../fn/user/test-firebird-db';
import { updateUserPofile } from '../fn/user/update-user-pofile';
import { updateUserPofile_1 } from '../fn/user/update-user-pofile-1';
import { UpdateUserPofile_1$Params } from '../fn/user/update-user-pofile-1';
import { updateUserPofile_2 } from '../fn/user/update-user-pofile-2';
import { UpdateUserPofile_2$Params } from '../fn/user/update-user-pofile-2';
import { UpdateUserPofile$Params } from '../fn/user/update-user-pofile';
import { uploadProfilePicture } from '../fn/user/upload-profile-picture';
import { uploadProfilePicture_1 } from '../fn/user/upload-profile-picture-1';
import { UploadProfilePicture_1$Params } from '../fn/user/upload-profile-picture-1';
import { UploadProfilePicture$Params } from '../fn/user/upload-profile-picture';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authenticate()` */
  static readonly AuthenticatePath = '/api/wtr/User/authenticate';

  /**
   * Sign in for user of type "Waiter".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticate()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authenticate$Response(params?: Authenticate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authenticate(this.http, this.rootUrl, params, context);
  }

  /**
   * Sign in for user of type "Waiter".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticate$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authenticate(params?: Authenticate$Params, context?: HttpContext): Observable<void> {
    return this.authenticate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `refreshToken()` */
  static readonly RefreshTokenPath = '/api/wtr/User/refresh-token';

  /**
   * Refresh token for user of type "Waiter".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refreshToken()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  refreshToken$Response(params?: RefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return refreshToken(this.http, this.rootUrl, params, context);
  }

  /**
   * Refresh token for user of type "Waiter".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refreshToken$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  refreshToken(params?: RefreshToken$Params, context?: HttpContext): Observable<void> {
    return this.refreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `revokeToken()` */
  static readonly RevokeTokenPath = '/api/wtr/User/signout';

  /**
   * Revoke token for user of type "Waiter".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeToken()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  revokeToken$Response(params?: RevokeToken$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return revokeToken(this.http, this.rootUrl, params, context);
  }

  /**
   * Revoke token for user of type "Waiter".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revokeToken$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  revokeToken(params?: RevokeToken$Params, context?: HttpContext): Observable<void> {
    return this.revokeToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUserProfile()` */
  static readonly GetUserProfilePath = '/api/wtr/User/getuserprofile';

  /**
   * Return Pos's user profile data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile$Response(params?: GetUserProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getUserProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Return Pos's user profile data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile(params?: GetUserProfile$Params, context?: HttpContext): Observable<void> {
    return this.getUserProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `registerFcmToken()` */
  static readonly RegisterFcmTokenPath = '/api/wtr/User/registerfcmtoken';

  /**
   * Regosters new fcm token for the authorized user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerFcmToken()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerFcmToken$Response(params?: RegisterFcmToken$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return registerFcmToken(this.http, this.rootUrl, params, context);
  }

  /**
   * Regosters new fcm token for the authorized user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerFcmToken$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerFcmToken(params?: RegisterFcmToken$Params, context?: HttpContext): Observable<void> {
    return this.registerFcmToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changelanguage()` */
  static readonly ChangelanguagePath = '/api/wtr/User/changelanguage';

  /**
   * Change the language for sign in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changelanguage()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changelanguage$Response(params?: Changelanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changelanguage(this.http, this.rootUrl, params, context);
  }

  /**
   * Change the language for sign in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changelanguage$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changelanguage(params?: Changelanguage$Params, context?: HttpContext): Observable<void> {
    return this.changelanguage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateUserPofile()` */
  static readonly UpdateUserPofilePath = '/api/wtr/User/updateuserpofile';

  /**
   * Update user profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserPofile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserPofile$Response(params?: UpdateUserPofile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUserPofile(this.http, this.rootUrl, params, context);
  }

  /**
   * Update user profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserPofile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserPofile(params?: UpdateUserPofile$Params, context?: HttpContext): Observable<void> {
    return this.updateUserPofile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authenticate_1()` */
  static readonly Authenticate_1Path = '/api/pos/User/authenticate';

  /**
   * Sign in for user of type "Pos General Manager".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticate_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authenticate_1$Response(params?: Authenticate_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authenticate_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Sign in for user of type "Pos General Manager".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticate_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authenticate_1(params?: Authenticate_1$Params, context?: HttpContext): Observable<void> {
    return this.authenticate_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `confirmPassword()` */
  static readonly ConfirmPasswordPath = '/api/pos/User/confirmpassword';

  /**
   * Confirm password for user of type "Pos General Manager or Pos Manager".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirmPassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  confirmPassword$Response(params?: ConfirmPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return confirmPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Confirm password for user of type "Pos General Manager or Pos Manager".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `confirmPassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  confirmPassword(params?: ConfirmPassword$Params, context?: HttpContext): Observable<void> {
    return this.confirmPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `forgotPassword()` */
  static readonly ForgotPasswordPath = '/api/pos/User/forgotpassword';

  /**
   * Restore forgoten password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forgotPassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  forgotPassword$Response(params?: ForgotPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return forgotPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Restore forgoten password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `forgotPassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  forgotPassword(params?: ForgotPassword$Params, context?: HttpContext): Observable<void> {
    return this.forgotPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getDailyOrderIncomings()` */
  static readonly GetDailyOrderIncomingsPath = '/api/pos/User/getdailyorderincomings';

  /**
   * Get incomings and number od orders for selected date.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDailyOrderIncomings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDailyOrderIncomings$Response(params?: GetDailyOrderIncomings$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getDailyOrderIncomings(this.http, this.rootUrl, params, context);
  }

  /**
   * Get incomings and number od orders for selected date.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDailyOrderIncomings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDailyOrderIncomings(params?: GetDailyOrderIncomings$Params, context?: HttpContext): Observable<void> {
    return this.getDailyOrderIncomings$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMostOrderedItems_2()` */
  static readonly GetMostOrderedItems_2Path = '/api/pos/User/getmostordereditems';

  /**
   * Get info for most ordered items from menu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMostOrderedItems_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMostOrderedItems_2$Response(params?: GetMostOrderedItems_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getMostOrderedItems_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Get info for most ordered items from menu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMostOrderedItems_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMostOrderedItems_2(params?: GetMostOrderedItems_2$Params, context?: HttpContext): Observable<void> {
    return this.getMostOrderedItems_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `revokeToken_1()` */
  static readonly RevokeToken_1Path = '/api/pos/User/signout';

  /**
   * Revoke token for user of type "Pos".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeToken_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeToken_1$Response(params?: RevokeToken_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return revokeToken_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Revoke token for user of type "Pos".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revokeToken_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeToken_1(params?: RevokeToken_1$Params, context?: HttpContext): Observable<void> {
    return this.revokeToken_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `refreshToken_1()` */
  static readonly RefreshToken_1Path = '/api/pos/User/refresh-token';

  /**
   * Refresh token for user of type "Pos General Manager" and "Pos Manager".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refreshToken_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  refreshToken_1$Response(params?: RefreshToken_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return refreshToken_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Refresh token for user of type "Pos General Manager" and "Pos Manager".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refreshToken_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  refreshToken_1(params?: RefreshToken_1$Params, context?: HttpContext): Observable<void> {
    return this.refreshToken_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changePassword()` */
  static readonly ChangePasswordPath = '/api/pos/User/changepassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changePassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changePassword$Response(params?: ChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changePassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changePassword(params?: ChangePassword$Params, context?: HttpContext): Observable<void> {
    return this.changePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUserProfile_1()` */
  static readonly GetUserProfile_1Path = '/api/mng/User/getuserprofile';

  /**
   * Return Pos's user profile data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfile_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile_1$Response(params?: GetUserProfile_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getUserProfile_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Return Pos's user profile data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfile_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile_1(params?: GetUserProfile_1$Params, context?: HttpContext): Observable<void> {
    return this.getUserProfile_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `registerFcmToken_1()` */
  static readonly RegisterFcmToken_1Path = '/api/mng/User/registerfcmtoken';

  /**
   * Regosters new fcm token for the authorized user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerFcmToken_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerFcmToken_1$Response(params?: RegisterFcmToken_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return registerFcmToken_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Regosters new fcm token for the authorized user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerFcmToken_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerFcmToken_1(params?: RegisterFcmToken_1$Params, context?: HttpContext): Observable<void> {
    return this.registerFcmToken_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changelanguage_1()` */
  static readonly Changelanguage_1Path = '/api/mng/User/changelanguage';

  /**
   * Change the language for sign in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changelanguage_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changelanguage_1$Response(params?: Changelanguage_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changelanguage_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Change the language for sign in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changelanguage_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changelanguage_1(params?: Changelanguage_1$Params, context?: HttpContext): Observable<void> {
    return this.changelanguage_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `uploadProfilePicture()` */
  static readonly UploadProfilePicturePath = '/api/mng/User/uploadprofilepicture';

  /**
   * Update profile picture for subscriber user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadProfilePicture()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadProfilePicture$Response(params?: UploadProfilePicture$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return uploadProfilePicture(this.http, this.rootUrl, params, context);
  }

  /**
   * Update profile picture for subscriber user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadProfilePicture$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadProfilePicture(params?: UploadProfilePicture$Params, context?: HttpContext): Observable<void> {
    return this.uploadProfilePicture$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateUserPofile_1()` */
  static readonly UpdateUserPofile_1Path = '/api/mng/User/updateuserpofile';

  /**
   * Update user profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserPofile_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserPofile_1$Response(params?: UpdateUserPofile_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUserPofile_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Update user profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserPofile_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserPofile_1(params?: UpdateUserPofile_1$Params, context?: HttpContext): Observable<void> {
    return this.updateUserPofile_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `register()` */
  static readonly RegisterPath = '/api/gmn/User/register';

  /**
   * Register new user of type "Pos General Manager".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `register()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  register$Response(params?: Register$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return register(this.http, this.rootUrl, params, context);
  }

  /**
   * Register new user of type "Pos General Manager".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `register$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  register(params?: Register$Params, context?: HttpContext): Observable<void> {
    return this.register$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUserProfile_2()` */
  static readonly GetUserProfile_2Path = '/api/gmn/User/getuserprofile';

  /**
   * Return Pos's user profile data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfile_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile_2$Response(params?: GetUserProfile_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getUserProfile_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Return Pos's user profile data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfile_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile_2(params?: GetUserProfile_2$Params, context?: HttpContext): Observable<void> {
    return this.getUserProfile_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateUserPofile_2()` */
  static readonly UpdateUserPofile_2Path = '/api/gmn/User/updateuserpofile';

  /**
   * Update user profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserPofile_2()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserPofile_2$Response(params?: UpdateUserPofile_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUserPofile_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Update user profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserPofile_2$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserPofile_2(params?: UpdateUserPofile_2$Params, context?: HttpContext): Observable<void> {
    return this.updateUserPofile_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `registerFcmToken_2()` */
  static readonly RegisterFcmToken_2Path = '/api/gmn/User/registerfcmtoken';

  /**
   * Regosters new fcm token for the authorized user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerFcmToken_2()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerFcmToken_2$Response(params?: RegisterFcmToken_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return registerFcmToken_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Regosters new fcm token for the authorized user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerFcmToken_2$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerFcmToken_2(params?: RegisterFcmToken_2$Params, context?: HttpContext): Observable<void> {
    return this.registerFcmToken_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changelanguage_2()` */
  static readonly Changelanguage_2Path = '/api/gmn/User/changelanguage';

  /**
   * Change the language for sign in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changelanguage_2()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changelanguage_2$Response(params?: Changelanguage_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changelanguage_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Change the language for sign in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changelanguage_2$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changelanguage_2(params?: Changelanguage_2$Params, context?: HttpContext): Observable<void> {
    return this.changelanguage_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllCountryNames()` */
  static readonly GetAllCountryNamesPath = '/api/gmn/User/getallcountrynames';

  /**
   * Get all country names in the system.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllCountryNames()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCountryNames$Response(params?: GetAllCountryNames$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getAllCountryNames(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all country names in the system.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllCountryNames$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCountryNames(params?: GetAllCountryNames$Params, context?: HttpContext): Observable<void> {
    return this.getAllCountryNames$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `uploadProfilePicture_1()` */
  static readonly UploadProfilePicture_1Path = '/api/gmn/User/uploadprofilepicture';

  /**
   * Update profile picture for subscriber user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadProfilePicture_1()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadProfilePicture_1$Response(params?: UploadProfilePicture_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return uploadProfilePicture_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Update profile picture for subscriber user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadProfilePicture_1$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadProfilePicture_1(params?: UploadProfilePicture_1$Params, context?: HttpContext): Observable<void> {
    return this.uploadProfilePicture_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `testFirebirdDb()` */
  static readonly TestFirebirdDbPath = '/api/gmn/User/TestFirebirdDB';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testFirebirdDb()` instead.
   *
   * This method doesn't expect any request body.
   */
  testFirebirdDb$Response(params?: TestFirebirdDb$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return testFirebirdDb(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `testFirebirdDb$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  testFirebirdDb(params?: TestFirebirdDb$Params, context?: HttpContext): Observable<void> {
    return this.testFirebirdDb$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
